import { gql } from "../generated-graphql";
import { StaffRolesQuery } from "../generated-graphql/graphql";

const GET_STAFF_ROLES_QUERY = gql(`
  query StaffRoles {
    staffRoles {
      id
      name
      description
      permissions
      userCount
      users {
        id
        email
        person {
          first
          last
        }
      }
    }
  }
`);

/** A staff role row as returned by {@link GET_STAFF_ROLES_QUERY} (members are a partial `User`). */
export type StaffRoleRow = StaffRolesQuery["staffRoles"][number];

export default GET_STAFF_ROLES_QUERY;
